import { ActionButtonFunctions } from "src/config/types";
import {
  NdtClient,
  NdtInput,
  NdtOutput,
} from "@npd-ng/network-diagnostic-tool";
import { TestStatus } from "../factories/ServiceTest";
import { Dispatch, SetStateAction } from "react";
import { getDomain, getENAEPDomain } from "../../util/util";

const sendToApi = (output: NdtOutput) => {
  try {
    const reportingEndpoint = `${window.location.origin}/api-student-data-services/v1/student-data-services/schools/network-readiness-result/`;
    output.ndtOutputReceiver = "ADS";
    const response = fetch(reportingEndpoint, {
      mode: "cors",
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Basic c2RzLWFwaS1iYXNpYy11c2VyOmlDQU1CRXJJRElsZQ==",
      },
      body: JSON.stringify(output),
    });
    console.log("[NDT]", response);
  } catch (e: any) {
    console.error("[NDT] error occured while posting results to api", e);
  }
};

export const handlers: ActionButtonFunctions = {
  setupCommonInput: (
    setStaus: Dispatch<SetStateAction<TestStatus>>,
    inputJson: NdtInput
  ): NdtInput => {
    setStaus({
      status: "Loading",
    });
    const inputParams: NdtInput = inputJson as unknown as NdtInput;
    const elem = document.getElementById("ndtContainer")!;

    function ExecutionSuccess(e: any) {
      setStaus({
        status: "Finished",
        response: e.detail as NdtOutput,
      });
      console.log(`NDTExecutionCompleted `, e.detail);
      elem.removeEventListener("NDTExecutionCompleted", ExecutionSuccess);
      elem.removeEventListener("NDTExecutionError", ExecutionError);
      sendToApi(e.detail);
    }

    function ExecutionError(e: any) {
      //returns NDTOutput
      const status =
        (e.detail as NdtOutput).ndtResults.details.safeList?.statusCode ===
        "7060"
          ? "NetworkError"
          : "Error";
      setStaus({
        status,
        response: e.detail as NdtOutput,
      });
      console.log("NDTExecutionError", e.detail);
      elem.removeEventListener("NDTExecutionCompleted", ExecutionSuccess);
      elem.removeEventListener("NDTExecutionError", ExecutionError);
      // NdtOutput
    }

    elem.addEventListener("NDTExecutionCompleted", ExecutionSuccess);
    elem.addEventListener("NDTExecutionError", ExecutionError);

    //example of switching environment
    const location = window.location.href;
    //how to switch client environment input paramenter by location
    inputParams.hostingClientDetails.clientEnvironment =
      location.indexOf("dev26") > -1 || location.indexOf("localhost") > -1
        ? "dev"
        : location.indexOf("devqc26") > -1
        ? "qa"
        : location.indexOf("prod") > -1 || location.indexOf("ed.gov") > -1
        ? "prod"
        : "stage";
    //on the backend, dcdc is reserved for download center
    inputParams.hostingClientDetails.setupCode = "DCDC";
    inputParams.hostingClientDetails.verificationCode = "DCDC";
    inputParams.hostingClientDetails.clientName = "DownloadCenter";
    inputParams.hostingClientDetails.schoolId = "99900072";
    inputParams.hostingClientDetails.preAssessmentPhase = "DV";
    inputParams.hostingClientDetails.parentElementId = "ndtContainer";
    return inputParams;
  },
  safeListCheck: (
    setStaus: Dispatch<SetStateAction<TestStatus>>,
    inputJson: NdtInput
  ) => {
    console.log(`safeListCheck`);
    const inputParams = handlers.setupCommonInput(setStaus, inputJson);
    
    const configRef =
      inputParams.environmentMap.find((e) => {
        return (
          e.clientEnvironment ===
          inputParams.hostingClientDetails.clientEnvironment
        );
      })?.configRef || "prod";

    inputParams[configRef].ndtConfiguration.rules.DV = {
      performSafeList: true,
      performContentFiltering:true,
      performSpeedTest: [],
      failJitter: false,
    };

    NdtClient.init(inputParams);
  },
  bandwidthCheck: (
    setStaus: Dispatch<SetStateAction<TestStatus>>,
    inputJson: NdtInput
  ) => {
    console.log(`bandwidthCheck`);
    if (!window.navigator.onLine) {
      setStaus({
        status: "Error",
        response: undefined,
      });
      return;
    }
    setStaus({
      status: "Loading",
    });
    const inputParams = handlers.setupCommonInput(setStaus, inputJson);
    const configRef =
      inputParams.environmentMap.find((e) => {
        return (
          e.clientEnvironment ===
          inputParams.hostingClientDetails.clientEnvironment
        );
      })?.configRef || "prod";
    inputParams[configRef].ndtConfiguration.rules.DV = {
      performSafeList: false,
      performContentFiltering:false,
      performSpeedTest: ["ookla-client", "enaep-speed-test-client"],
      failJitter: false
    };
    let enaepST;
    for(const agent of inputParams[configRef].ndtConfiguration.speedTest.agents){
      if(agent.name === 'enaep-speed-test-client')
        enaepST = agent;
    }
    if(enaepST){
      enaepST.url = `${window.location.origin}/download-center/enaep-speed-test-custom/index.html`
    }
    NdtClient.init(inputParams);
  },
};
